import {
  CrisisAlertRounded,
  CurrencyExchangeRounded,
  HomeRounded,
  LocalPrintshopRounded,
  LocalOfferRounded,
  //StadiumRounded,
} from "@mui/icons-material";
import { Paper } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { controller, endpoints } from "../../api/actions/api";
import * as actions from "../../api/actions/pos";
import { AppContext } from "../../App";
import { Button } from "../../controls";
import { NestedFormData, RmvEmptyProp } from "../../hooks/Method";
import { safeOnComplete } from "../../utils/safeOnComplete";

import {
  printReceiptHtmlDirect,
  buildReceiptHtml,
  getPrintAgentStatus,
} from "../../api/actions/printAgent";

const Actions = (props) => {
  const { t } = useTranslation();
  const {
    _get,
    _post,
    _store,
    handleClearCart,
    _authUser,
    setReceiptData,
    cartItems,
    subTotal,
    tax,
    setAlert,
  } = props;
  const { setCLoader } = useContext(AppContext);

  const navigate = useNavigate();


  const printLastSale = async () => {

    const agentStatus =
      await getPrintAgentStatus();

    if (!agentStatus.running) {
      setAlert({
        isOpen: true,
        type: "warning",
        title: t("printAgentNotRunning"),
        subTitle: t("printAgentNotRunningMessage"),
      });

      return;
    }    

    if (!_store?.id) {
      setAlert({
        isOpen: true,
        type: "warning",
        title: t("printer"),
        subTitle: t("noStoreSelected"),
      });
      return;
    }

    setCLoader(true);

    // Printer Type 1 = POS Receipt
    const printerType = 1;

    const onPrinterComplete = safeOnComplete(
      (printerRes) => {
        if (
          printerRes.status !== 200 ||
          !printerRes.result
        ) {
          setCLoader(false);

          setAlert({
            isOpen: true,
            type: "warning",
            title: t("printer"),
            subTitle: t("noDefaultReceiptPrinter"), 
          });

          return;
        }

        const printer = printerRes.result;

        // Now get the last sale
        const onSaleComplete = safeOnComplete(
          (res) => {
            if (
              res.status === 200 &&
              res.result !== null
            ) {
              setReceiptData(res.result);

              // Build the real receipt text
              // Wait for React to render the receipt with
            // the new last-sale data.
            setTimeout(() => {
              const receiptElement =
                document.getElementById("printSellReceipt");

              if (!receiptElement) {
                console.error(
                  "DIRECT PRINT ERROR: printSellReceipt was not found."
                );
                return;
              }

              const receiptHtml = buildReceiptHtml(
                receiptElement,
                printer.paperWidth || 80
              );

              // Used the installed printer
              printReceiptHtmlDirect(
                printer.printerName,
                receiptHtml,
                printer.paperWidth || 80
              )
                .then((result) => {
                  console.log(
                    "REAL HTML RECEIPT DIRECT PRINT:",
                    result
                  );
                })

               .catch((err) => {
                console.error(
                  "HTML DIRECT PRINT ERROR:",
                  err
                );

                setAlert({
                  isOpen: true,
                  type: "warning",
                  title: t("receiptNotPrinted"),
                  subTitle: t("receiptNotPrintedMessage"),
                });
              });

            }, 500);

              // Keep old browser print temporarily
              setTimeout(() => {
               // PrintDiv("printSellReceipt");
                setCLoader(false);
              }, 1000);
            } else {
              setCLoader(false);

              setAlert({
                isOpen: true,
                type: "warning",
                title: t("warning"),
                subTitle: t("noLastSaleData"),
              });
            }
          },
          (err) => {
            setCLoader(false);

            setAlert({
              isOpen: true,
              type: "error",
              title: t("error"),
              subTitle: err?.msg || t("unableToLoadLastSale"),
            });
          }
        );

        _get(
          endpoints.Sell + controller.GetLastSell,
          null,
          onSaleComplete
        );
      },
      (err) => {
        setCLoader(false);

        setAlert({
          isOpen: true,
          type: "warning",
          title: t("printer"),
          subTitle:
            err?.msg || t("noDefaultReceiptPrinter"),
        });
      }
    );

    _get(
      endpoints.StorePrinter +
        controller.GetDefaultPrinter +
        `/${_store.id}/${printerType}`,
      null,
      onPrinterComplete
    );
  };

  const handlePrintLastSale = () => {
  setAlert({
    isOpen: true,
    type: "confirmation",
    title: t("printLastSaleReceipt"),
    subTitle: t("printLastSaleConfirmation"),
    onConfirm: () => {
      setAlert({
        isOpen: false,
      });

      printLastSale();
    },
  });
};

  const handleRefund = () => {
    navigate("refund");
  };

  
  const handleVoidSell = () => {
    const voidVal = {
      items: cartItems.map((j) =>
        j.itemType === 2 ? { ...j, productId: "" } : j
      ),
      tax: tax,
      cancelType: 1,
      subtotal: subTotal,
      userId: _authUser.id,
      storeId: _store.id,
    };

    setAlert({
      isOpen: true,
      type: "confirmation",
      title: t("areYouSure"),
      subTitle: t("voidSaleConfirmation"),
      onConfirm: () => {
        const onComplete = safeOnComplete(
          (res) => {
            if (res.status === 201) {
              setAlert({
                isOpen: true,
                type: "success",
                title: t("successful"),
                subTitle: t("saleVoidedSuccessfully"),
              });
              handleClearCart();
            } else {
              setAlert({
                isOpen: true,
                type: "warning",
                title: t("warning"),
                subTitle: res.msg,
              });
            }
          },
          (err) => {
            setAlert({
              isOpen: true,
              type: "error",
              title: t("error"),
              subTitle: err.msg,
            });
          }
        );

        _post(
          endpoints.VoidSell,
          NestedFormData(RmvEmptyProp(voidVal)),
          null,
          onComplete
        );
      },
    });
  };

  return (
    <>
      <Paper
        className="mt-20 shadow-xs br-8 p-10 d-flex"
        sx={{
          minHeight: "80px",
          flexWrap: { xs: "wrap", md: "inherit" },
        }}
      >
        <Button
          onClick={() => navigate("/pos")}
          variant="outlined"
          fullWidth
          sx={{
            display: "block",
            mr: { xs: "0px", md: "10px" },
            mb: { xs: "10px", md: "0px" },
            "& .MuiButton-startIcon": { mr: 0 },
          }}
          startIcon={<HomeRounded className="fs-30" />}
        >
          {t("home")}
        </Button>
        <Button
          onClick={() => navigate("discount")}
          variant="outlined"
          fullWidth
          sx={{
            display: "block",
            mr: { xs: "0px", md: "10px" },
            mb: { xs: "10px", md: "0px" },
            "& .MuiButton-startIcon": { mr: 0 },
          }}
          startIcon={<LocalOfferRounded className="fs-30" />}
        >
          {t("discount")}
        </Button>
        <Button
          onClick={() => navigate("print-receipt")}
          variant="outlined"
          fullWidth
          sx={{
            display: "block",
            mr: { xs: "0px", md: "10px" },
            mb: { xs: "10px", md: "0px" },
            "& .MuiButton-startIcon": { mr: 0 },
          }}
          startIcon={<LocalPrintshopRounded className="fs-30" />}
        >
          {t("printReceipt")}
        </Button>        
        <Button
          onClick={handleVoidSell}
          variant="outlined"
          fullWidth
          sx={{
            display: "block",
            mr: { xs: "0px", md: "10px" },
            mb: { xs: "10px", md: "0px" },
            "& .MuiButton-startIcon": { mr: 0 },
          }}
          startIcon={<CrisisAlertRounded className="fs-30" />}
        >
          {t("voidSell")}
        </Button>
        <Button
          onClick={handleRefund}
          variant="outlined"
          fullWidth
          sx={{ display: "block" }}
          startIcon={<CurrencyExchangeRounded className="fs-30" />}
        >
          {t("refund")}
        </Button>
      </Paper>
    </>
  );
};

const mapStateToProps = (state) => ({
  _authUser: state.pos.authUser,
  _store: state.pos.defStore,
});

const mapActionToProps = {
  _get: actions.get,
  _post: actions.post,
};

export default connect(mapStateToProps, mapActionToProps)(Actions);
